import { Container, Stack } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';

import RecommendationResult from '../Global/RecommendationResult';

import { recommendationResponse } from '../services/RecommendationApiResult';

function ViewRecommendation() {
  const [getrecomdationDataList, setGetrecomdationDataList] = useState([]);

  useEffect(() => {
    callRecommresult();
  }, []);

  const callRecommresult = async () => {
    const getrecomdationData = await recommendationResponse();
    setGetrecomdationDataList(getrecomdationData);
  };
  return (
    <Page title="Klass Management System || Leads">
      <Container maxWidth="xl" style={{ paddingBottom: '50px' }}>
        <Box pt={3} pb={3}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Recommendation" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
        </Box>
        <RecommendationResult addCase="no" getrecomdationDataList={getrecomdationDataList} />
      </Container>
    </Page>
  );
}
export default ViewRecommendation;
